<template>
  <div>
    <section class="profile__block">
      <div class="profile__block__header">
        <h2>{{ getTranslations.home_profile_profile_edit_set_profile_picture }}</h2>
      </div>
      <div class="profile__block__content profile__block__content--edit-avatar">
        <div class="tab-header">
          <a style="cursor:pointer" class="active" data-target="male">{{ getTranslations.home_profile_profile_edit_gender_male }}</a>
          <a style="cursor:pointer" class="" data-target="female">{{ getTranslations.home_profile_profile_edit_gender_female }}</a>
        </div>
        <div class="tab-container">
          <div class="tab-container__item tab-container__item--avatar active" id="male">
            <div class="select-edit-avatar">
              <a style="cursor:pointer" :class="[ 'avatar', (userAvatar === userDetails.facebookImage || userAvatar === 'static/images/avatar_default.png') ? 'active' : '', (userDetails.facebookImage) ? 'facebook_active' : 'facebook_inactive'  ]" id="default-avatar">
                <span class="fb_show">{{ getTranslations.home_fb_facebook_avatar }}</span>
                <span class="fb_hide">{{ getTranslations.home_profile_profile_edit_personalize_avatar_default }}</span>
                <div v-if="userDetails.displayAvatar === true">
                  <div v-if="userDetails.facebookImage">
                    <img class="fb_show" :src="userDetails.facebookImage" alt="">
                  </div>
                  <div v-else>
                    <img class="fb_hide" src="static/images/avatar_default.png" alt="">
                  </div>
                </div>
                <div v-if="userDetails.displayAvatar === false">
                  <img class="fb_show" :src="userDetails.facebookImage" alt="">
                </div>
              </a>
              <a style="cursor:pointer" :class="[ 'avatar', (userAvatar === userDetails.avatar && userAvatar !== 'static/images/avatar_default.png') ? 'active' : '' ]" data-gender="male">
                <span>{{ getTranslations.home_profile_profile_edit_personalize_avatar_male }}</span>
                <div v-if="userDetails.displayAvatar === true">
                  <div v-if="userDetails.avatar === 'static/images/avatar_default.png'">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_1.png' ]" alt="">
                  </div>
                  <div v-else>
                    <div v-if="userDetails.avatarGender === 'female'">
                      <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_1.png' ]" alt="">
                    </div>
                    <div v-else>
                      <img :src="userDetails.avatar" alt="">
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div v-if="userDetails.avatar === 'static/images/avatar_default.png'">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_1.png' ]" alt="">
                  </div>
                  <div v-else>
                    <div v-if="userDetails.avatarGender === 'female'">
                      <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_1.png' ]" alt="">
                    </div>
                    <div v-else>
                      <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_1.png' ]" alt="">
                    </div>
                    <!--<img :src="userDetails.avatar" alt="">-->
                  </div>
                </div>
              </a>
            </div>
            <div class="avatar-studio" id="studio_male">

              <div class="avatar-studio__main">
                <canvas class="canvas_avatar canvas_avatar--male" width="250" height="250"></canvas>
                <div class="avatar-studio__main__nav studio_nav">
                  <a style="cursor:pointer" class="prev" data-value="prev"><i class="icon-arrow-left"></i></a>
                  <a style="cursor:pointer" class="next" data-value="next"><i class="icon-arrow-right"></i></a>
                </div>
                <div class="avatar-options">
                  <div class="avatar-options__items hair">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_1.png' ]" alt="" width="250" height="250" data-value="single" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping +  '/male/Avatar_2.png' ]" alt="" width="250" height="250" data-value="color1" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_3.png' ]" alt="" width="250" height="250" data-value="color2" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_4.png' ]" alt="" width="250" height="250" data-value="color3" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_5.png' ]" alt="" width="250" height="250" data-value="color4" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_6.png' ]" alt="" width="250" height="250" data-value="color5" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_7.png' ]" alt="" width="250" height="250" data-value="color6" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_8.png' ]" alt="" width="250" height="250" data-value="sleeves" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_9.png' ]" alt="" width="250" height="250" data-value="sleeves1" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_10.png' ]" alt="" width="250" height="250" data-value="sleeves2" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_11.png' ]" alt="" width="250" height="250" data-value="sleeves3" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_12.png' ]" alt="" width="250" height="250" data-value="sleeves4" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_13.png' ]" alt="" width="250" height="250" data-value="sleeves5" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_14.png' ]" alt="" width="250" height="250" data-value="sleeves6" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_15.png' ]" alt="" width="250" height="250" data-value="sleeves7" data-gender="male">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_16.png' ]" alt="" width="250" height="250" data-value="stripes" data-gender="male">
                  </div>
                  <div class="avatar-options__items skin">
                    <img :src="[ 'static/images/avatar_'+ avatarGrouping+ '/male/Avatar_1.png' ]" width="250" height="250" alt="" data-value="white" data-gender="male">
                  </div>
                </div>
              </div>
              <a style="cursor:pointer"
                 class="btn btn--medium btn--main save-btn">{{ getTranslations.home_profile_profile_edit_personalize_avatar_save
                }}</a>
            </div>
          </div>
          <div class="tab-container__item tab-container__item--avatar" id="female">
            <div class="select-edit-avatar">

              <a style="cursor: pointer" :class="[ 'avatar', (userAvatar === userDetails.facebookImage || userAvatar === 'static/images/avatar_default.png') ? 'active' : '', (userDetails.facebookImage) ? 'facebook_active' : 'facebook_inactive'  ]" id="default-avatar-female">
                <span class="fb_show">{{ getTranslations.home_fb_facebook_avatar }}</span>
                <span class="fb_hide">{{ getTranslations.home_profile_profile_edit_personalize_avatar_default }}</span>
                <div v-if="userDetails.displayAvatar === true">
                  <div v-if="userDetails.facebookImage">
                    <img class="fb_show" :src="userDetails.facebookImage" alt="">
                  </div>
                  <div v-else>
                    <img class="fb_hide" src="static/images/avatar_default.png" alt="">
                  </div>
                </div>
                <div v-if="userDetails.displayAvatar === false">
                  <img class="fb_show" :src="userDetails.facebookImage" alt="">
                </div>
              </a>
              <a style="cursor: pointer" :class="[ 'avatar', (userAvatar === userDetails.avatar && userAvatar !== 'static/images/avatar_default.png') ? 'active' : '' ]" data-gender="female">
                <span>{{ getTranslations.home_profile_profile_edit_personalize_avatar_female }}</span>
                <div v-if="userDetails.displayAvatar === true">
                  <div v-if="userDetails.avatar == 'static/images/avatar_default.png'">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_1.png' ]" alt="">
                  </div>
                  <div v-else>
                    <div v-if="userDetails.avatarGender === 'male'">
                      <img :src="[ 'static/images/avatar_'+ avatarGrouping + '/male/Avatar_1.png' ]" alt="">
                    </div>
                    <div v-else>
                      <img :src="userDetails.avatar" alt="">
                    </div>
                  </div>
                </div>
                <div v-if="userDetails.displayAvatar === false">
                  <div v-if="userDetails.avatar === 'static/images/avatar_default.png'">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_1.png' ]" alt="">
                  </div>
                  <div v-else>
                    <div v-if="userDetails.avatarGender === 'male'">
                      <img :src="[ 'static/images/avatar_' + avatarGrouping + '/male/Avatar_1.png' ]" alt="">
                    </div>
                    <div v-else>
                      <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_1.png' ]" alt="">
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div class="avatar-studio" id="studio_female">

              <div class="avatar-studio__main">
                <canvas class="canvas_avatar canvas_avatar--female" width="250" height="250"></canvas>
                <div class="avatar-studio__main__nav studio_nav">
                  <a style="cursor:pointer" class="prev" data-value="prev"><i class="icon-arrow-left"></i></a>
                  <a style="cursor:pointer" class="next" data-value="next"><i class="icon-arrow-right"></i></a>
                </div>
                <div class="avatar-options">
                  <div class="avatar-options__items hair">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_1.png' ]" alt="" width="250" height="250" data-value="single" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_2.png' ]" alt="" width="250" height="250" data-value="color1" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_3.png' ]" alt="" width="250" height="250" data-value="color2" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_4.png' ]" alt="" width="250" height="250" data-value="color3" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_5.png' ]" alt="" width="250" height="250" data-value="color4" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_6.png' ]" alt="" width="250" height="250" data-value="color5" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_7.png' ]" alt="" width="250" height="250" data-value="color6" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_8.png' ]" alt="" width="250" height="250" data-value="sleeves" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_9.png' ]" alt="" width="250" height="250" data-value="sleeves1" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_10.png' ]" alt="" width="250" height="250" data-value="sleeves2" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_11.png' ]" alt="" width="250" height="250" data-value="sleeves3" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_12.png' ]" alt="" width="250" height="250" data-value="sleeves4" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_13.png' ]" alt="" width="250" height="250" data-value="sleeves5" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_14.png' ]" alt="" width="250" height="250" data-value="sleeves6" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_15.png' ]" alt="" width="250" height="250" data-value="sleeves7" data-gender="female">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_16.png' ]" alt="" width="250" height="250" data-value="stripes" data-gender="female">
                  </div>
                  <div class="avatar-options__items skin">
                    <img :src="[ 'static/images/avatar_' + avatarGrouping + '/female/Avatar_1.png' ]" width="250" height="250" alt="" data-value="white" data-gender="female">
                  </div>

                </div>
              </div>
              <a style="cursor: pointer" class="btn btn--medium btn--main save-btn">{{ getTranslations.home_profile_profile_edit_personalize_avatar_save
                }}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <facebook-login v-if="!userDetails.facebookId && facebookFunctionality"
                    :enteredUsername="userDetails.username"
                    :previousComponentFacebook="editProfilePage">
    </facebook-login>

    <section class="profile__block "><!--ADD CLASS fb_on IF THE USER IS ALREADY LOGGEDIN WITH FACEBOOK else REMOVE-->
      <div class="profile__block__header">
        <h2>{{ getTranslations.home_profile_profile_edit_change_username || 'Change Username'}}</h2>
      </div>
      <div class="profile__block__content profile__block__content--password">
        <form @submit.prevent="updateUsernameAction">
          <div class="form-group form-group--icon" :class="[ !hasErrorsChangeUsername ? '' : 'has-warning' ]">
            <input type="username" class="form-group__textfield"
                   :class="[ !hasErrorsChangeUsername ? 'has-success' : 'has-warning' ]"
                   :placeholder="getTranslations.home_profile_profile_edit_placeholder_enter_username || 'Enter username'"
                   @keyup="checkUsername"
                   v-model="username"/>
            <span v-show="getMessage(messageForUsername) && hasErrorsChangeUsername"
                  class="form-group__feedback">{{ getMessage(hasErrorsChangeUsername) }}</span>
            <i class="icon-lock"></i>
          </div>

          <button type="submit"
                  :class="[hasErrorsChangeUsername || !username ? 'deactivated' : '']">
            {{ getTranslations.home_profile_profile_edit_placeholder_update_username || 'Update Username' }}
          </button>
        </form>
      </div>
    </section>


    <section v-if="!hideChangePassword && !userDetails.facebookId" class="profile__block">
      <div class="profile__block__header">
        <h2>{{ getTranslations.home_profile_profile_edit_change_password }}</h2>
      </div>
      <div class="profile__block__content profile__block__content--password">
        <form action="">
          <div class="form-group form-group--icon" :class="[ !hasErrorsPasswordOld ? '' : 'has-warning' ]">
            <input type="password" class="form-group__textfield"
                   :class="[ !hasErrorsPasswordOld ? 'has-success' : 'has-warning' ]"
                   :placeholder="getTranslations.home_profile_profile_edit_placeholder_enter_password"
                   @keyup="checkPasswordOld"
                   v-model="passwordOld"/>
            <span v-show="getMessage(messageForInitialPassword) && hasErrorsPasswordOld"
                  class="form-group__feedback">{{ getMessage(messageForInitialPassword) }}</span>
            <i class="icon-lock"></i>
          </div>
          <div class="login-form__forgot-password">
            <router-link :to="'forgotPassword1'">{{ getTranslations.home_profile_profile_edit_forgot_password }}
            </router-link>
          </div>
          <div class="form-group form-group--icon" :class="[ !hasErrorsPassword ? '' : 'has-warning' ]">
            <input type="password" class="form-group__textfield"
                   :class="[ !hasErrorsPassword ? 'has-success' : 'has-warning' ]"
                   :placeholder="getTranslations.home_profile_profile_edit_placeholder_enter_password_min_6_chars"
                   @keyup="checkPassword" v-model="passwordNew"/>
            <span v-show="getMessage(messageForPassword) && hasErrorsPassword"
                  class="form-group__feedback">{{ getMessage(messageForPassword) }}</span>
            <i class="icon-lock"></i>
          </div>
          <div class="form-group form-group--icon"
               :class="[ !hasErrorsConfirmPassword ? '' : 'has-warning' ]">
            <input type="password" class="form-group__textfield"
                   :class="[ !hasErrorsConfirmPassword ? 'has-success' : 'has-warning' ]"
                   :placeholder="getTranslations.home_profile_profile_edit_placeholder_re_enter_password"
                   @keyup="checkPassword"
                   v-model="confirmPassword"/>
            <span v-show="getMessage(message)"
                  class="form-group__feedback">{{ getMessage(message) }}</span>
            <i class="icon-lock"></i>
          </div>
          <button type="submit"
                  class="btn btn--medium btn--main"
                  @click.prevent="checkButton">{{ getTranslations.home_profile_profile_edit_button_update }}
          </button>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import FacebookLogin from '@/components/visitor/FacebookLogin';
import RegistrationFlowMixin from '@/common/mixins/flow';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'profile-edit',
  mixins: [RegistrationFlowMixin],
  components: {
    FacebookLogin,
  },
  data() {
    return {
      confirmPassword: '',
      passwordOld: '',
      passwordNew: '',
      message: '',
      messageForPassword: '',
      messageForInitialPassword: '',
      hasErrorsPasswordOld: false,
      hasErrorsPassword: false,
      hasErrorsConfirmPassword: false,
      editProfilePage: 'editProfile',
      hasErrorsChangeUsername: false,
      username: '',
      messageForUsername: '',
    };
  },
  created() {
    this.setProfilePath(false);
  },
  beforeDestroy() {
    this.setProfilePath(true);
  },
  mounted() {
    const vm = this;
    this.$nextTick(() => {
      /* eslint-disable */
      let finalGender = null;
      $('#default-avatar').click(function (e) {
        e.preventDefault();
        console.log('Default Avatar choice for Male Gender');
        if (vm.userDetails.displayAvatar === true) {
          if (vm.userDetails.facebookImage) {
            vm.updateDisplayAvatar();
          } else {
            localStorage.setItem('Avatar', 'static/images/avatar_default.png');
            vm.sendAvatarCall(finalGender);
          }
        }
        vm.$router.push('/home/profile');
      });
        $('#default-avatar-female').click(function (e) {
          e.preventDefault();
          console.log('Default Avatar choice for FeMale Gender');
          if (vm.userDetails.displayAvatar === true) {
            if (vm.userDetails.facebookImage) {
              vm.updateDisplayAvatar();
            } else {
              localStorage.setItem('Avatar', 'static/images/avatar_default.png');
              vm.sendAvatarCall(finalGender);
            }
          } else {
            // vm.updateDisplayAvatar();
          }
          vm.$router.push('/home/profile');
        });

      $('.tab-header a').click(function (e) {
        e.preventDefault();
        const $this = $(this);
        const target = $this.data('target');
        if (!$this.hasClass('active')) {
          $('.tab-header a').removeClass('active');
          $this.addClass('active');
          $('.tab-container__item.active').fadeOut(200, function () {
            $('.tab-container__item').removeClass('active');
            $('#' + target).fadeIn(200, function () {
              $(this).addClass('active');
            });
          });
        }
      });

      $('.select-edit-avatar a').click(function (e) {
        e.preventDefault();

        var gender = $(this).data('gender');
        finalGender = gender;
        if (gender == "male") {
          initAvatarState();
          window.avatarState.avatar.gender = "male";
          initCanvas(window.avatarState.avatar.gender);
          $(this).parent().fadeOut(200, function () {
            $('#studio_male').fadeIn(200);
            $('#studio_female').fadeOut(200);
            $('#female .select-edit-avatar').fadeIn();
          });

        }
        else if (gender == "female") {
          $(this).parent().fadeOut(200, function () {
            $('#studio_female').fadeIn(200);
            $('#studio_male').fadeOut(200);
            $('#male .select-edit-avatar').fadeIn();
          });
          initAvatarState();
          window.avatarState.avatar.gender = "female";
          initCanvas(window.avatarState.avatar.gender);
        }
      });

      $('.studio_nav a').click(function (e) {
        e.preventDefault();
        const countImages = avatarImages[window.avatarState.edit][window.avatarState.avatar.gender].length;
        const direction = $(this).data('value');
        if (direction === "prev") {
          currentItem--;
        }
        else if (direction === "next") {
          currentItem++;
        }
        if (currentItem < 0) {
          currentItem = countImages - 1;
        }
        if (currentItem >= countImages) {
          currentItem = 0;
        }
        window.avatarState.avatar[window.avatarState.edit] = avatarImages[window.avatarState.edit][window.avatarState.avatar.gender][currentItem].value;
        updateCanvas();
      });

      $('.avatar-option').click(function (e) {
        e.preventDefault();
        $('.avatar-option').removeClass('active');
        $(this).addClass('active');
        window.avatarState.edit = $('a', this).data('value');
        currentItem = 0;
      });

      $('.save-btn').click(function (e) {
        e.preventDefault();
        $(this).attr('href', canvas.toDataURL("image/png"));
        localStorage.setItem('Avatar', canvas.toDataURL("image/png"));
        vm.sendAvatarCall(finalGender).then(() => {
          if (vm.userDetails.displayAvatar === false) {
            vm.updateDisplayAvatar();
          }
          vm.$router.push('/home/profile');
        });
      });

      const initAvatarState = function () {
        window.avatarState = {
          edit: 'hair',
          avatar: {
            gender: 'male',
            hair: 'single',
          }
        };
      };

      let canvas;
      let ctx;
      const hair = new Image;
      const avatarImages = {};
      let currentItem = 0;

      const initCanvas = function (gender) {
        canvas = $('.canvas_avatar--' + gender)[0];
        ctx = canvas.getContext("2d");
        updateCanvas();
        getImages();
      };

      const getImages = function () {
        var temp = [];
        temp['female'] = [];
        temp['male'] = [];
        $(".skin > img").each(function () {
          if ($(this).data('gender') !== "undefined") {
            temp[$(this).data('gender')].push({value: $(this).data('value'), src: $(this).attr('src')});
          }
        });
        avatarImages['skin'] = temp;
        temp = [];
        temp['female'] = [];
        temp['male'] = [];
        $(".hair > img").each(function () {
          if ($(this).data('gender') !== "undefined") {
            temp[$(this).data('gender')].push({value: $(this).data('value'), src: $(this).attr('src')});
          }
        });
        avatarImages['hair'] = temp;
      };

      const updateCanvas = function () {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        canvasHair();
      };

      const canvasHair = function () {
        hair.onload = function () {
          ctx.drawImage(this,
            canvas.width / 2 - hair.width / 2,
            canvas.height / 2 - hair.height / 2,
            this.width,
            this.height
          );
        };
        hair.src = $(".hair [data-value='" + window.avatarState.avatar.hair + "']").filter(".hair [data-gender='" + window.avatarState.avatar.gender + "']").attr('src');
      };
      /* eslint-enable */
    });
  },
  methods: {
    ...mapActions('profile', [
      'logoutUserFromAuthorizedPages',
      'changeUsername',
      'storeLoginInfo',
    ]),
    ...mapMutations('common', [
      'setProfilePath',
      'updateUsername',
    ]),
    ...mapActions('common', [
      'sendAvatarCall',
      'updateDisplayAvatar',
      'sendFacebookImage',
    ]),
    getMessage(key) {
      return this.getTranslations[key] || '';
    },
    checkMaxChar(value, max, evt) {
      if (value.length > max) {
        /*eslint-disable */
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode.which < 0x20) {
          // e.which < 0x20, then it's not a printable character
          // e.which === 0 - Not a character
          return;     // Do nothing
        }
        if (value.length == max) {
          charCode.preventDefault();
//            return false;
        } else if (value.length > max) {
          // Maximum exceeded
//            this.user.password = this.user.password.substring(0, max);
          return value.substring(0, max);
        }
        /* eslint-enable */
      }
    },
    checkPasswordOld() {
      const min = this.hasSimplify() ? 4 : 6;
      const max = 12;
      this.hasErrorsPasswordOld = false;
      this.hasErrorsConfirmPassword = false;
      this.hasErrorsPassword = false;
      this.message = '';
      this.messageForPassword = '';
      this.messageForInitialPassword = '';
      if (this.passwordOld.length < min || this.passwordOld.length > max) {
        this.messageForInitialPassword = 'home_profile_profile_edit_wrong_password_warning_msg_at_least_6_chars';
        this.hasErrorsPasswordOld = true;
      }
      if (this.passwordOld === '') {
        this.hasErrorsPasswordOld = false;
      }
    },
    checkPassword(evt) {
      const min = this.hasSimplify() ? 4 : 6;
      const max = 12;
      // eslint-disable-next-line
      const validPasswordRegex = /^(?!.*[\0\b\n\f\r\t\s-!@#\$%\=.^\&*(\+\/?\[\]|΄΄;:<>}{'"¨,)`~\\])_?.+$/;
      // https://stackoverflow.com/questions/1559751/regex-to-make-sure-that-the-string-contains-at-least-one-lower-case-char-upper
      const validUsername = this.passwordNew.match(validPasswordRegex);
      this.message = '';
      this.hasErrorsPassword = false;
      if (this.passwordNew.length < min) {
        this.messageForPassword = 'home_profile_profile_edit_wrong_password_warning_msg_at_least_6_chars';
        this.hasErrorsPassword = true;
      } else if (this.passwordNew.length > max) {
        this.passwordNew = this.checkMaxChar(this.passwordNew, max, evt);
        this.hasErrorsPassword = true;
        this.checkPassword();
      } else if (validUsername !== null) {
        if (this.passwordNew.length > max) {
          this.passwordNew = this.checkMaxChar(this.passwordNew, max, evt);
          this.hasErrorsPassword = true;
          this.checkPassword();
        }
        this.messageForPassword = '';
        this.message = '';
        if (this.confirmPassword !== '' && (this.confirmPassword === this.passwordNew)) {
          this.messageForPassword = '';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = false;
        } else {
          this.message = 'home_profile_profile_edit_msg_warning_entered_passwords_not_match';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = true;
        }
      } else if (validUsername === null) {
        this.hasErrorsPassword = true;
        // eslint-disable-next-line
        this.messageForPassword = 'home_profile_profile_edit_msg_password_cannot_contain_any_other_symbols_except_from_';
      }
      if (this.passwordNew === '') {
        this.hasErrorsPassword = false;
        this.hasErrorsConfirmPassword = false;
      } else if (this.confirmPassword === '' && this.passwordNew === '') {
        this.hasErrorsConfirmPassword = false;
      }
    },
    checkButton() {
      if (this.passwordOld === '' || this.hasErrorsPasswordOld) {
        if (!this.messageForInitialPassword) this.messageForInitialPassword = 'home_profile_profile_edit_msg_warning_invalid_password';
        this.hasErrorsPasswordOld = true;
      } else if (this.passwordNew === '' || this.hasErrorsPassword) {
        if (!this.messageForPassword) this.messageForPassword = 'home_profile_profile_edit_msg_warning_invalid_password';
        this.hasErrorsPassword = true;
      } else if (this.confirmPassword === '' || this.hasErrorsConfirmPassword) {
        if (!this.message) this.message = 'home_profile_profile_edit_msg_warning_invalid_password';
        this.hasErrorsConfirmPassword = true;
      } else {
        this.message = '';
        this.$axios({
          url: 'api/changePassword',
          method: 'POST',
          headers: {
            Authorization: this.jwtInVuex,
          },
          data: {
            passwordOld: this.passwordOld,
            password: this.confirmPassword,
          },
        }).then((response) => {
          this.messageForInitialPassword = '';
          this.hasErrorsPasswordOld = false;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            this.message = 'home_profile_profile_edit_password_updated';
          } else if (response.data.responseEnum === 'SERVER_ERROR') {
            this.hasErrorsConfirmPassword = true;
            this.message = 'home_profile_profile_edit_server_unvailable';
          } else {
            this.messageForInitialPassword = 'home_profile_profile_edit_msg_warning_invalid_password';
            this.hasErrorsPasswordOld = true;
          }
        }).catch((error) => {
          this.logoutUserFromAuthorizedPages();
          console.log(`Invoking changePassword failed with the following error: ${error}`);
        });
      }
    },

    async checkUsername(evt) {
      const max = 12;
      const min = 3;
      this.resetValidation();

      if (!this.username) {
        return;
      }

      if (!this.isValidLength(min, max, evt)) {
        return;
      }

      if (!this.isValidFormat()) {
        return;
      }

      await this.checkUsernameAvailability();
    },

    resetValidation() {
      this.hasErrorsChangeUsername = false;
      this.messageForUsername = '';
    },

    isValidLength(min, max, evt) {
      if (this.username.length < min) {
        this.messageForUsername = 'home_profile_profile_edit_warning_msg_username_at_least_3_chars_long';
        this.hasErrorsChangeUsername = true;
        return false;
      }

      if (this.username.length > max) {
        this.username = this.checkUsernameMaxChar(this.username, max, evt);
        this.hasErrorsChangeUsername = true;
        return false;
      }

      return true;
    },

    checkUsernameMaxChar(value, max, evt) {
      if (value.length > max) {
        /* eslint-disable */
        evt = (evt) ? evt : window.event;
        let charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode.which < 0x20) {
          return;     // Do nothing
        }
        if (value.length === max) {
          charCode.preventDefault();
        } else if (value.length > max) {
          return value.substring(0, max);
        }
        /* eslint-enable */
      }
    },

    isValidFormat() {
      // eslint-disable-next-line no-useless-escape
      const validUsernameRegex = /^(?!.*[\0\b\n\f\r\t\s-!@#\$%\=.^\&*(\+\/?\[\]|΄΄;:<>}{'"¨,)`~\\])_?.+$/;
      if (!this.username.match(validUsernameRegex)) {
        this.messageForUsername = 'home_profile_profile_edit_warning_msg_username_criteria';
        this.hasErrorsChangeUsername = true;
        return false;
      }

      return true;
    },


    async checkUsernameAvailability() {
      try {
        const response = await this.$axios.get(`publicapi/checkUsername?username=${this.username}&msisdn=${encodeURIComponent(this.userDetails.msisdn)}`);

        const res = response.data.data.msg;

        if (res === 'Username exists') {
          this.messageForUsername = 'home_profile_profile_edit_warning_msg_username_taken_below';
          this.hasErrorsChangeUsername = true;
        } else if (res === 'Invalid') {
          this.messageForUsername = 'home_profile_profile_edit_warning_msg_username_blacklist_word';
          this.hasErrorsChangeUsername = true;
        } else {
          this.messageForUsername = res;
        }
      } catch (error) {
        console.error('Error checking username availability:', error);
        this.hasErrorsChangeUsername = true;
        this.messageForUsername = 'common_error_generic';
      }
    },

    updateUsernameAction() {
      if (!this.username) return;

      if (!this.hasErrorsChangeUsername) {
        this.changeUsername({ username: this.username }).then((response) => {
          const res = response.data.responseEnum;
          if (res === 'OPERATION_SUCCESS') {
            this.success = true;
            this.updateUsername(this.username);
            this.storeLoginInfo({ token: response.data.data, username: this.username, rememberMeParameter: true });
            this.hasErrorsChangeUsername = false;
          } else {
            this.hasErrorsChangeUsername = true;
          }
        });
      } else {
        this.hasErrorsChangeUsername = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'hideChangePassword',
      'userDetails',
      'userAvatar',
      'facebookFunctionality',
      'avatarGrouping',
    ]),
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/ProfileEdit.vue